import { createApp } from 'vue'

import router from './router'

import { showToast } from './utils/Toaster'

// CSS files import (order matter karta hai)
import './assets/themes/css/sidebar-menu.css'
import './assets/themes/css/simplebar.css'
import './assets/themes/css/prism.css'
import './assets/themes/css/quill.snow.css'
import './assets/themes/css/remixicon.css'
import './assets/themes/css/swiper-bundle.min.css'
import './assets/themes/css/jsvectormap.min.css'
import './assets/themes/css/style.css'
import FileUploader from './components/FileUploader.vue'
import App from './App.vue'
import './assets/css/filters.css'
import './assets/js/filters.js'
import './assets/css/rform.css'
const app = createApp(App)

// Make toast available globally in all components
app.config.globalProperties.$toast = showToast
if(localStorage.getItem('user_token')) {
    app.config.globalProperties.$token = localStorage.getItem('user_token')
}
app.config.globalProperties.$backend_domain = "https://api.fvopex.com/"
//  app.config.globalProperties.$backend_domain = "http://127.0.0.1:8000/"

function limit_text(text, length = 20, suffix = '...') {
      if (!text) return '';
      if (text.length <= length) return text;
      return text.substring(0, length) + suffix;
    }
    app.config.globalProperties.$limit = limit_text

app.use(router)
app.component('FileUploader', FileUploader)
app.mount('#app')

// localStorage.setItem('user_token', result.data.token);